import React, {useEffect, useState} from 'react';

import classNames from "classnames";
import styles from "./scrollabe-shadow.module.scss";

import {useEventListener} from "../../../../infrastructure/hooks/useEventListener";
import {WithDevice} from "../../composers/with-device";

export const ScrollableShadow = WithDevice(({
                                              children,
                                              scrollableElement,
                                              firstShadowMaxWidth,
                                              lastShadowMaxWidth,
                                              showShadow,
                                              leftOffset,
                                              className,
                                              rowsLength,
                                              device: {isRtl},
                                              id
                                            }) => {

  useEventListener('scroll', (e) => updateScrollPosition(e), scrollableElement, {passive: true});

  const [firstWidth, setFirstWidth] = useState(0)
  const [lastWidth, setLastWidth] = useState(lastShadowMaxWidth)
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if ((scrollableElement?.scrollWidth - scrollableElement?.clientWidth > 0) || showShadow) {
      setHeight(scrollableElement?.clientHeight);
    }
  }, [scrollableElement?.clientHeight, rowsLength, id]);

  const updateScrollPosition = (e) => {
    const position: Number = Math.abs(e.target.scrollLeft)

    setFirstWidth(Math.min(position, firstShadowMaxWidth));
    setLastWidth(Math.min(e.target.scrollWidth - position - e.target.clientWidth, lastShadowMaxWidth));
  }

  const leftShadowProps = {
    className: classNames(styles.shadow, styles.first, className),
    style: {
      width: firstWidth,
      [isRtl ? 'right' : 'left']: leftOffset,
      height,
      zIndex: 1
    }
  }

  const rightShadowProps = {
    className: classNames(styles.shadow, styles.last),
    style: {
      width: lastWidth,
      height,
      zIndex: 1
    }
  }

  return (
    <>
      {
        showShadow ? <>
          <div {...leftShadowProps}/>
          <div {...rightShadowProps}/>
        </> : null
      }
      {
        children
      }
    </>
  )
});
